import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DeregistrationPack} from '../../../shared/interface/deregistration-pack';
import {Registration} from '../../../shared/interface/registration';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {DeregistrationPackService} from '../../../shared/services/deregistration-pack.service';
import {MatSnackBar} from '@angular/material/snack-bar';

export interface AddRegistrationDialogData {
  deregistrationPackObject?: DeregistrationPack;
  registrationObject?: Registration;
}

@Component({
  selector: 'app-add-registration',
  templateUrl: './add-registration.component.html',
  styleUrls: ['./add-registration.component.scss']
})
export class AddRegistrationComponent implements OnInit {

  addRegistrationForm: FormGroup;
  deregistrationPackControl: FormControl;
  registrationControl: FormControl;
  deregistrationPackObject?: DeregistrationPack;
  registrationObject?: Registration;
  processingRequest = false;

  constructor(
    public dialogRef: MatDialogRef<AddRegistrationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddRegistrationDialogData,
    private fb: FormBuilder,
    private deregistrationPackService: DeregistrationPackService,
    private snack: MatSnackBar,
  ) {
    this.registrationObject = data.registrationObject;
    this.deregistrationPackObject = data.deregistrationPackObject;
    this.addRegistrationForm = fb.group({
      deregistrationPack: this.deregistrationPackControl = fb.control('', [Validators.required]),
      registration: this.registrationControl = fb.control('', [Validators.required]),
    });

    if (this.registrationObject) {
      this.registrationControl.setValue(this.registrationObject.uuid);
    }

    if (this.deregistrationPackObject) {
      this.deregistrationPackControl.setValue(this.deregistrationPackObject.uuid);
    }
  }

  ngOnInit(): void {
  }

  closeDialog(e): void {
    this.dialogRef.close(e);
  }

  save(): void {
    this.processingRequest = true;

    this.deregistrationPackService.addRegistrationToPack(
      this.registrationControl.value,
      this.deregistrationPackControl.value
    ).subscribe(() => {
      this.dialogRef.close();
      this.snack.open('Dodano rejestrację do paczki', '', {duration: 2000});
    }, () => {
      this.snack.open('Przy dodawaniu rejestracji do paczki wystąpił błąd', '', {duration: 2000});
      this.processingRequest = false;
    });
  }
}
